import { render, staticRenderFns } from "./AllPublications.vue?vue&type=template&id=1bf41bca"
import script from "./AllPublications.vue?vue&type=script&lang=js"
export * from "./AllPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports